import React from 'react';
import ReactModal from 'react-modal';
import * as ReactRedux from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { createSampleDocument } from 'SelfServeBuilder/SelfServeBuilderActions';
import SelfServeBuilderEnum from 'SelfServeBuilder/SelfServeBuilderConstants';
import { CloseSmallIcon } from 'DesignSystem/Icons';
import { Pill } from 'DesignSystem';
import styles from '../../../../sass/main.scss';

const defaultModalStyle = {

  overlay: {
    background: 'transparent',
    zIndex: styles.modalZIndex,
  },
  content: {
    position: 'absolute',
    top: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    boxShadow: '0 2px 4px 0 rgba(0,0,0,0.5)',
    backgroundColor: 'white',
    height: 375,
    paddingTop: 0,
    width: 550,
    overflow: 'visible',
  },
};


class NoSignatureToTemplateBuilderModal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.declineDemo = this.declineDemo.bind(this);
    this.tryDemo = this.tryDemo.bind(this);
  }

  declineDemo() {
    window._track('Maybe Later | No One Request Signature Modal', 'Static-Builder-Member');
    this.props.closeModal();
  }

  tryDemo() {
    window._track('Try Demo | No One Request Signature Modal', 'Static-Builder-Member');
    this.props.createSampleDocument(
      SelfServeBuilderEnum.SELF_SERVE_BUILDER_SAMPLE_DOCUMENT_CONTRACT,
    );
  }

  render() {
    return (
      <ReactModal
        style={defaultModalStyle}
        ariaHideApp={false}
        isOpen={this.props.isOpen}
        onRequestClose={this.props.closeModal}
        shouldCloseOnOverlayClick
      >
        <div className="no-signature-template-builder-modal">
          <CloseSmallIcon
            className="ds-icon-default cursor-pointer close-icon"
            onClick={this.props.closeModal}
          />
          <img
            alt="convert to custom template"
            className="custom-template-icon"
            src="/images/builder-static/make-template-2x.png"
          />
          <div className="modal-header-wrapper">
            <Pill
              className="new-badge"
              type="alt"
            >
               NEW
            </Pill>
            <h3 className="modal-header">
            Turn your documents into this question-style format.
            </h3>
          </div>
          <div className="modal-text-wrapper">
            <p className="modal-text">
              Your recipients can quickly and accurately fill out what you need.
            </p>
          </div>
          <div className="modal-actions-wrapper">
            <button
              className="ds-btn-secondary md"
              onClick={this.declineDemo}
            >
              Maybe Later
            </button>
            <button
              className="ds-btn-primary md"
              onClick={this.tryDemo}
            >
              Try a Demo
            </button>
          </div>
        </div>
      </ReactModal>
    );
  }
}

NoSignatureToTemplateBuilderModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  createSampleDocument: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    createSampleDocument,
  }, dispatch)
);

export const NoSignatureToTemplateBuilderModalWithRedux = ReactRedux.connect(
  null,
  mapDispatchToProps,
)(NoSignatureToTemplateBuilderModal);

export default NoSignatureToTemplateBuilderModalWithRedux;



// WEBPACK FOOTER //
// ./src-react/StaticRequestSignatureContentSection/components/Modals/NoSignatureToTemplateBuilderModal.jsx